import React from "react";
import { Table, Button, Space, Popconfirm, Tag,Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";


const MenuTable = ({ data, loading, onEdit, onDelete,cat }) => {
  console.log(cat);
  
  const categoryMap = {};
cat.forEach(item => {
  categoryMap[item.id] = item.name.trim();
});

  const columns = [
    {
      title: "Menu Name",
      dataIndex: "name"
    },
    {
      title: "Category",
      dataIndex: "category_id",
        render: (category_id) => categoryMap[category_id] || "-"
    },
    {
      title: "Veg / Non-veg",
      dataIndex: "is_veg",
       render: (is_veg) => (
        <Tag color={is_veg === 1 ? "green" : "red"}>
          {is_veg === 1 ? "Veg" : "Non-Veg"}
        </Tag>
      ),
    },
    {
  title: (
    <Space>
      Price

      <Tooltip title="Non AC Price ">
        <InfoCircleOutlined
          style={{
            color: "#1890ff",
            fontSize: "14px",
            cursor: "pointer",
          }}
        />
      </Tooltip>
    </Space>
  ),
  dataIndex: "price",
},
    
    {
      title: "Tax (%)",
      dataIndex: "tax_pct"
    },
    {
      title: "Status",
      dataIndex: "is_active",
       render: (is_active) => (
              <Tag color={is_active === 1 ? "green" : "red"}>
                {is_active === 1 ? "Active" : "Inactive"}
              </Tag>
            ),
    },
    {
      title: "Action",
      render: (_, record) => (
        <Space>
          <Button type="link" onClick={() => onEdit(record)}>
            Edit
          </Button>

          <Popconfirm
            title="Delete menu?"
            onConfirm={() => onDelete(record.id)}
          >
            <Button danger type="link">
              Delete
            </Button>
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={data}
      loading={loading}
    />
  );
};

export default MenuTable;